import { UseSWROutput, useSWR } from '~/hooks/useSWR';
import { MyWorkspaceUserSettingsKey } from '~/scenes/MyWorkspace/userSettings';
import { IAm, PreferencesApiClient } from '~/services/Http';

export type UserPreferences = {
  useWorkspaceAsHomepage?: boolean;
  [p: string]: unknown;
};

export const saveUserPreferencesData = (newData: UserPreferences) => {
  return PreferencesApiClient.getPreferences([MyWorkspaceUserSettingsKey]).then(
    (r) => {
      const currentData = r.data[MyWorkspaceUserSettingsKey] ?? {
        workspaces: [],
      };

      const updatedData = newData.useWorkspaceAsHomepage
        ? { ...currentData, useWorkspaceAsHomepage: true }
        : (() => {
            const { useWorkspaceAsHomepage: _, ...rest } = currentData;
            return rest;
          })();

      return PreferencesApiClient.setPreferences(
        IAm.UserPreferencesInputDto.fromJS({
          data: { [MyWorkspaceUserSettingsKey]: updatedData },
        }),
      );
    },
  );
};

export const useGetUserPreferencesData = (
  isDisabled?: boolean,
): UseSWROutput<UserPreferences> & {
  hasData: boolean;
} => {
  const preferencesKey = MyWorkspaceUserSettingsKey;

  const results = useSWR(
    !isDisabled ? ['userPreferences', preferencesKey] : null,
    () =>
      PreferencesApiClient.getPreferences([preferencesKey]).then((r) => {
        return r.data[preferencesKey] ?? {};
      }),
  );

  return {
    ...results,
    hasData: typeof results.data !== 'undefined',
  };
};
